import en from './en-US.json'
import zh from './zh-CN.json'

export const defaultLocale = 'en'

export const languages = {
  'en-US': en,
  'zh-CN': zh,
}
